<template>
    <v-dialog :value="dialog" width="800px">
        <v-card>
            <v-card-title
                    class="blue-grey darken-1 py-4 title"
            >
                Wedstrijd {{key === null ? 'maken' : 'aanpassen'}}
            </v-card-title>
            <v-container grid-list-sm class="pa-4">
                <v-layout row wrap>
                    <v-flex xs12 align-center justify-space-between>
                        <v-layout align-center>
                            <v-text-field
                                    label="Thuisploeg"
                                    v-model="hometeam"
                            ></v-text-field>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 align-center justify-space-between>
                        <v-layout align-center>
                            <v-text-field
                                    label="Omschrijving"
                                    v-model="description"
                            ></v-text-field>
                        </v-layout>
                    </v-flex>
                    <v-flex xs6>
                        <v-date-picker
                                label="Datum"
                                v-model="date"
                                :events="matchDates"
                                event-color="green lighten-1"
                        ></v-date-picker>
                    </v-flex>
                    <v-flex xs6>
                        <v-time-picker
                                label="Time"
                                v-model="time"
                                format="24hr"
                        ></v-time-picker>
                    </v-flex>
                    <v-flex xs12>
                        <v-select
                                label="Type"
                                :items="items"
                                v-model="type"
                        ></v-select>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="closeDialog">Cancel</v-btn>
                <v-btn flat dark @click="resetTribunes">Reset tribunes</v-btn>
                <template v-if="key === null">
                    <v-btn flat dark @click="addMatch">Aanmaken</v-btn>
                </template>
                <template v-else>
                    <v-btn flat dark @click="editMatch">Aanpassingen opslaan</v-btn>
                </template>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { db } from "../../firebase";
import dateFormat from "dateformat";
export default {
  name: "MatchDialog",
  props: {
    dialog: Boolean,
    matchDates: Array,
    selectedMatch: Object
  },
  data: function() {
    return {
      items: [
        { value: "regular", text: "Gewone match" },
        { value: "special", text: "Bekermatch" }
      ],
      key: null,
      hometeam: "KFC Dessel",
      description: "",
      date: "",
      time: null,
      type: "regular",
      places: 0,
      placesSold: 0,
      tribunes: {}
    };
  },
  watch: {
    selectedMatch: function(newVal) {
      if (newVal !== null) {
        this.key = newVal[".key"];
        this.hometeam = newVal.hometeam;
        this.description = newVal.description;
        this.type = newVal.type;
        this.date = dateFormat(newVal.date.toDate(), "isoDate");
        this.time = dateFormat(newVal.date.toDate(), "isoTime");
      }
    }
  },
  mounted() {
    this.setupTribunesData();
  },
  firestore() {
    return {
      matches: db.collection("matches")
    };
  },
  methods: {
    resetData: function() {
      this.hometeam = "KFC Dessel";
      this.description = "";
      this.date = "";
      this.time = null;
      this.key = null;
      this.type = "regular";
      this.places = 0;
      this.placesSold = 0;
      this.tribunes = {};
      this.setupTribunesData();
    },
    closeDialog: function() {
      this.$emit("closeDialog", true);
      this.resetData();
    },
    resetTribunes: function() {
      if (confirm("Ben je zeker dat je de verkochte plaatsen wil resetten?")) {
        this.setupTribunesData();
        const matchData = this.buildMatchData(true);
        matchData.places = this.places;
        matchData.placesSold = this.placesSold;
        matchData.tribunes = this.tribunes;
        db.collection("matches")
          .doc(this.key)
          .update(matchData);
      }
    },
    addMatch: function() {
      db.collection("matches").add(this.buildMatchData());
      this.closeDialog();
    },
    editMatch: function() {
      db.collection("matches")
        .doc(this.key)
        .update(this.buildMatchData(true));
      this.closeDialog();
    },
    setupTribunesData: function() {
      db.collection("tribunes")
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach((tribune) => {
            this.places = this.places + tribune.data().places;
            this.tribunes[tribune.id] = {
              tribuneKey: tribune.id,
              description: tribune.data().description,
              places: tribune.data().places,
              placesSold: 0,
              locationsSold: {},
              type: tribune.data().type,
              block: tribune.data().block
            };
          });
        });
    },
    buildMatchData(update = false) {
      const match = {
        hometeam: this.hometeam,
        description: this.description,
        date: new Date(this.date + " " + this.time),
        type: this.type
      };
      if (update) {
        match.updated = new Date();
      } else {
        match.timestamp = new Date();
        match.places = this.places;
        match.placesSold = this.placesSold;
        match.tribunes = this.tribunes;
      }

      return match;
    }
  }
};
</script>
